export default "__VITE_ASSET__0b6049a1__"